import React from "react";
import styled from "styled-components";

export default styled.span`
    margin-right: 10px;
    width: 10px;
    height: 10px;
    float: left;
    border-radius: 300px;
    border: 2px solid grey;

    ${(props) => (props.active ? {
    'background': '#5562C0',
    'border': '2px solid #5562C0'
} : '')}
`;